import React from 'react'
import { TableProps } from '@commonTypes'
import css from './detailsTable.module.scss'

interface IProps extends TableProps {
  children: React.ReactNode
  width?: string
}

const Table = ({ children, ...rest }: IProps) => {
  return (
    <table className={css.s_table} {...rest}>
      <tbody>{children}</tbody>
    </table>
  )
}
export function Optional({ editing, required }: { editing?: boolean; required?: boolean }) {
  if (!editing || required) return null
  return <div className={css.s_table}>Optional</div>
}

Table.Optional = Optional
export default Table
